import Module from '../Module';
import { $t } from "../i18n";

export default class Summary extends Module {
    constructor(title, index, dataProcessingConsentText, dataProtectionUrl) {
        // Chain constructor with super
        super(title, index, 'summary');
        this._title = title || $t('mod.summary.title')
        this._renderThankYou = false;
        this._dataProcessingConsentText = dataProcessingConsentText || $t('mod.summary.dataProcessing.text')
        this._dataProtectionUrl = dataProtectionUrl || $t('mod.summary.privacyPolicy.defaultUrl')
        this._dataProcessingConsent = false;
    }

    get dataProcessingConsentText() {
        return this._dataProcessingConsentText;
    }

    get dataProcessingConsentHtml() {
      const searchText = $t('mod.summary.privacyPolicy.linkReplaceSearchText')
      const regexp = new RegExp(`(${searchText})`)
        let html = this.dataProcessingConsentText.replace(regexp, `<a href="${this._dataProtectionUrl}" target="_blank">$1</a>`);
        if (html === this.dataProcessingConsentText) {
          const label = $t('mod.summary.privacyPolicyOpen.openLabel')
            html += `<br><a href="' + this._dataProtectionUrl + '" target="_blank">${label}</a>`
        }
        return html;
    }

    get dataProcessingConsent() {
        return this._dataProcessingConsent;
    }

    set dataProcessingConsent(value) {
        this._dataProcessingConsent = value;
    }

    get renderThankYou() {
        return this._renderThankYou;
    }

    set renderThankYou(renderThankYou) {
        this._renderThankYou = renderThankYou;
    }

    fillDummyData() {
        this._dataProcessingConsent = true;
    }

    removeDummyData() {
        this._dataProcessingConsent = false;
    }
}